import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
}), 'Lens');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Lens.js
// module id = 4450
// module chunks = 2